/**
 * @generated SignedSource<<fe0639851d82b3c6d915c12ce4c9d041>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type workItemsTable_AtlassianConversationAssistantPreviewCard_Row_issueType$data = {
  readonly " $fragmentSpreads": FragmentRefs<"JiraIssueTypeIcon_Platform">;
  readonly " $fragmentType": "workItemsTable_AtlassianConversationAssistantPreviewCard_Row_issueType";
};
export type workItemsTable_AtlassianConversationAssistantPreviewCard_Row_issueType$key = {
  readonly " $data"?: workItemsTable_AtlassianConversationAssistantPreviewCard_Row_issueType$data;
  readonly " $fragmentSpreads": FragmentRefs<"workItemsTable_AtlassianConversationAssistantPreviewCard_Row_issueType">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "workItemsTable_AtlassianConversationAssistantPreviewCard_Row_issueType",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "JiraIssueTypeIcon_Platform"
    }
  ],
  "type": "JiraIssueType"
};

(node as any).hash = "3d777c04058ec8abae13d390800dd4aa";

export default node;
